<div class="itineraryCabin__cabin-info" *ngIf="isAvailable">
  <div>
    <app-ds-typography
      [size]="typographySizeXXS"
      [text]="'FLIGHT_ITEM_DETAIL_MODULE.CABIN.TITLE_DETAIL' | transloco"
      [color]="secondaryTextColor">
    </app-ds-typography>
  </div>
  <div class="itineraryCabin__cabin-info__cabin-detail"
    (click)="openCabinDetailClicked()">
    <div class="itineraryCabin__cabin-info__cabin-detail__cabin-type">
      <app-ds-typography
        [size]="typographySizeXXS"
        [text]="airplane"
        [color]="primaryTextColor">
      </app-ds-typography>
    </div>
    <div class="itineraryCabin__cabin-info__cabin-detail__amenitie-list">
      <ng-container *ngIf="cabinAmenities.Entertainment">
        <app-ds-icon
          [icon]="iconInFlightEntertainment"
          [size]="18"
          [color]="iconFillColor.Primary">
        </app-ds-icon>
      </ng-container>
      <ng-container *ngIf="cabinAmenities.Power">
        <app-ds-icon
          [icon]="iconPower"
          [size]="18"
          [color]="iconFillColor.Primary">
        </app-ds-icon>
      </ng-container>
      <ng-container *ngIf="cabinAmenities.Wifi">
        <app-ds-icon
          [icon]="iconWifi"
          [size]="18"
          [color]="iconFillColor.Primary">
        </app-ds-icon>
      </ng-container>
    </div>
    <div class="itineraryCabin__cabin-info__cabin-detail__cabin-action">
      <ng-container *ngIf="isLoadingFlightCabin; else iconChevron">
        <app-ds-loader-ring
          [size]="'12px'"
          [type]="loaderRingType">
        </app-ds-loader-ring>
      </ng-container>
      <ng-template #iconChevron>
        <app-ds-icon
          [icon]="iconChevronRight"
          [size]="12"
          [color]="iconFillColor.Primary">
        </app-ds-icon>
      </ng-template>
    </div>
  </div>
  <div class="itineraryCabin__cabin-info__divider">
    <app-ds-divider></app-ds-divider>
  </div>
</div>

<ng-container *ngIf="show">
  <ng-container *ngIf="isLoadedWithResult">
    <ng-container *ngIf="isMobile; else cabinDetailDesktop">
      <ng-container *ngTemplateOutlet="cabinDetailMobile"></ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #cabinDetailMobile>
  <app-itinerary-cabin-detail
    [airplane]="airplane"
    [airlineName]="airlineName"
    [cabin]="flightCabinSelected"
    (closeCabinDetail)="closeCabinDetail()"></app-itinerary-cabin-detail>
</ng-template>

<ng-template #cabinDetailDesktop>
  <app-modal
    [width]="950"
    [noMaxHeight]="true"
    (toggleModal)="closeCabinDetail()">
    <ng-container content>
      <app-itinerary-cabin-detail-desktop
        *ngIf="!isLoadingFlightCabin"
        [airplane]="airplane"
        [airlineName]="airlineName"
        [cabin]="flightCabinSelected"
        (closeCabinDetail)="closeCabinDetail()"></app-itinerary-cabin-detail-desktop>
    </ng-container>
  </app-modal>
</ng-template>
